import React, { useState, useEffect } from 'react';
import { Field, Formik, Form } from 'formik';
import { TextInput } from '../../../../components';
import { useSelector, useDispatch } from 'react-redux';
import CaseReportFilesForm from "./CaseReportFilesForm";
import { storeEconomicDamage } from '../../../../redux/actions/economicDamage';
import { cancelCaseSubmission, formikRefCapture } from '../../../../redux/actions/liabilty';
import { isCaseSaved } from '../../../../redux/actions/liabilty';
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import CaseFormFooter from "../../../../components/ui-control/CaseFormFooter";

const EconomicDamageAnalysisForm = ({ onSubmit, stepDecrement, backToCases,innerRef,plainTiffs,selectedTiffIndex, formSteps }) => {
    const dispatch = useDispatch();
    const damageAnalysis = useSelector(state => state.economicDamage.damage);
    const isSavingProgress = useSelector(state => state.SaveCaseProgress.saveCaseProgress);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formValues, setFormValues] = useState({})
    useEffect(() => {
        dispatch(formikRefCapture(innerRef))
    }, [])

    useEffect(() => {
        if (damageAnalysis) {
            setFormValues(damageAnalysis);
        }

    }, [damageAnalysis])

    const handlePrevious = (values) => {
        stepDecrement();
        setFormValues(values);
        dispatch(storeEconomicDamage(values))
        setIsSubmitting(true);
    };

    const removeLossOfEarningFile = (formik,key, fileToRemove) => {
        let updatedArray = Array.from(formik?.values.ecoDamage[selectedTiffIndex]?.lossOfEarning).filter(file => file !== fileToRemove);
        formik.setFieldValue(key, updatedArray);
    }

    const removeMedicalExpensesFile = (formik,key, fileToRemove) => {
        let updatedArray = Array.from(formik?.values.ecoDamage[selectedTiffIndex]?.futureMedicalExpense).filter(file => file !== fileToRemove);
        formik.setFieldValue(key, updatedArray);
    }

    const fileUploadFunc = (formik, fileKey, files) => {
        const prevFiles = formik.values[fileKey] || [];
        const combinedArr = [...prevFiles, ...files?.file];
        const uniqueFileArr = [...new Map(combinedArr.map(item => [item.name, item])).values()];
        formik.setFieldValue(fileKey, uniqueFileArr);
    }
    const ecoDamage = formValues?.ecoDamage ?? [];
    return (
        <Formik
            initialValues={{
                ecoDamage : Array.from({length:plainTiffs.length},(_,i)=>{
                    const existingDamageData = ecoDamage?.[i] || {};
                    return {
                        workHoursMissed: existingDamageData.workHoursMissed || '',
                        hourlyIncomeRate: existingDamageData.hourlyIncomeRate || '',
                        typeofWork: existingDamageData.typeofWork || '',
                        lossOfEarning:  Array.isArray(existingDamageData.lossOfEarning) ? [...existingDamageData.lossOfEarning] : [],
                        futureMedicalExpense: Array.isArray(existingDamageData.futureMedicalExpense) ? [...existingDamageData.futureMedicalExpense] : [],
                    }
                })
                
            }}
            enableReinitialize={true}
            onSubmit={(values) => {
                dispatch(cancelCaseSubmission(true));
                dispatch(storeEconomicDamage(values));
                if (isSavingProgress) {
                    values.processCase = false;
                    onSubmit({ damage: values });
                } else if (isSubmitting) {
                    values.processCase = false;
                } else {
                    values.processCase = true;
                    // dispatch(isCaseSaved(true)); // This cause call addCase again  
                    onSubmit({ damage: values });
                }
                setIsSubmitting(false);
            }}
        >
            {(formik) => (
                <Form
                    onKeyDown={(e) => handleEnterKeyPress(e)}
                >
                    <div className="add-form p-0">
                        <div className='form-background form-item-pd'>
                        <h3 className="form-title mb-6 fs-4">Future Economic Damages</h3>
                        <h3 className="form-title mb-6">Loss of Earnings</h3>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <Field
                                        name={`ecoDamage[${selectedTiffIndex}].workHoursMissed`}
                                        placeholder="Write hours..."
                                        label="Work Hours Missed"
                                        component={TextInput}
                                        isRenderCommaDecimal={true}
                                        onChange={e => {
                                            formik.setFieldValue(`ecoDamage[${selectedTiffIndex}].workHoursMissed`, e.target.value);
                                            const updated = { ...formik.values };
                                            updated.ecoDamage[selectedTiffIndex].workHoursMissed = e.target.value;
                                            dispatch(storeEconomicDamage(updated));
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <Field
                                        name={`ecoDamage[${selectedTiffIndex}].hourlyIncomeRate`}
                                        type="text"
                                        label="Hourly Income Rate"
                                        placeholder="Enter here"
                                        shouldUserRenderIcon={<><span style={{ position: 'absolute', color: '#18479a', left: '12px', top: '8px' }}>$</span></>}
                                        component={TextInput}
                                        shouldDollarRender={true}
                                        isDollarSignRender={true}
                                        onChange={e => {
                                            formik.setFieldValue(`ecoDamage[${selectedTiffIndex}].hourlyIncomeRate`, e.target.value);
                                            const updated = { ...formik.values };
                                            updated.ecoDamage[selectedTiffIndex].hourlyIncomeRate = e.target.value;
                                            dispatch(storeEconomicDamage(updated));
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <Field
                                        name={`ecoDamage[${selectedTiffIndex}].typeofWork`}
                                        label="Enter Type of Work"
                                        placeholder="Enter here"
                                        component={TextInput}
                                        onChange={e => {
                                            formik.setFieldValue(`ecoDamage[${selectedTiffIndex}].typeofWork`, e.target.value);
                                            const updated = { ...formik.values };
                                            updated.ecoDamage[selectedTiffIndex].typeofWork = e.target.value;
                                            dispatch(storeEconomicDamage(updated));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <CaseReportFilesForm
                                                onFileSelected={(files) => {
                                                    fileUploadFunc(formik, `ecoDamage[${selectedTiffIndex}].lossOfEarning`, files);
                                                }}
                                                fileNames={formik.values?.ecoDamage[selectedTiffIndex]?.lossOfEarning?.length > 0 ? formik.values?.ecoDamage[selectedTiffIndex]?.lossOfEarning : []}
                                                fieldName='lossOfEarning'
                                                documentName='lossOfEarning'
                                                reportName='Loss of Earnings'
                                                removeFile={(file) => removeLossOfEarningFile(formik,`ecoDamage[${selectedTiffIndex}].lossOfEarning`, file)}
                                                uploadButtonText='Upload Documents'
                                                isRenderLiabilityFiles= {false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h2 className="form-title mb-6">Future Medical Expenses
                            </h2>
                            <div className="row mt-1 mb-3">
                                <div className="col-md-12">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <CaseReportFilesForm
                                                onFileSelected={(files) => {
                                                    fileUploadFunc(formik, `ecoDamage[${selectedTiffIndex}].futureMedicalExpense`, files);
                                                }}
                                                fileNames={formik.values?.ecoDamage[selectedTiffIndex]?.futureMedicalExpense?.length > 0 ? formik.values?.ecoDamage[selectedTiffIndex]?.futureMedicalExpense : []}
                                                fieldName='futureMedicalExpense'
                                                documentName='futureMedicalExpense'
                                                reportName='Future Medical Expenses'
                                                removeFile={(file) => removeMedicalExpensesFile(formik,`ecoDamage[${selectedTiffIndex}].futureMedicalExpense`, file)}
                                                uploadButtonText='Upload Documents'
                                                isRenderLiabilityFiles= {false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CaseFormFooter backToCases={backToCases} handlePrevious={handlePrevious} innerRef={innerRef}  formSteps={formSteps} values={formik.values}/>
                    </div>
                </Form>
            )
            }
        </Formik >
    )
}

export default EconomicDamageAnalysisForm;